import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Box} from "app/archivage/common/services/box/box.model";
import {UntypedFormControl} from "@angular/forms";
import {debounceTime, distinctUntilChanged, switchMap, throttleTime} from "rxjs/operators";
import {BoxService} from "app/archivage/common/services/box/box.service";
import {SubSink} from "@Common/core/utils/subsink";

@Component({
  selector: 'app-boite-observation',
  templateUrl: './boite-observation.component.html',
  styleUrls: ['./boite-observation.component.scss']
})
export class BoiteObservationComponent implements OnInit, OnDestroy {
  subSink = new SubSink();

  @Input() box: Box;

  autoSaveDone = true;

  observation = new UntypedFormControl();
  constructor(
    private boxSvc: BoxService
  ) { }

  ngOnInit(): void {
    this.observation.setValue(this.box?.observation);
    this.subSink.sink = this.observation.valueChanges
      .pipe (
      debounceTime(300),
      distinctUntilChanged(),
      switchMap(() => this.boxSvc.patch({id: this.box.id, observation: this.observation.value}))
      )
      .subscribe((val) => this.autoSaveDone = true);
    this.subSink.sink = this.observation.valueChanges
      .pipe(
        throttleTime(1000)
      )
      .subscribe((val) => this.autoSaveDone = false);
  }

  ngOnDestroy() {
    this.subSink.unsubscribe();
  }
}
